import { render, staticRenderFns } from "./ImportGroup.vue?vue&type=template&id=183bb0cf&scoped=true"
import script from "./ImportGroup.vue?vue&type=script&lang=ts"
export * from "./ImportGroup.vue?vue&type=script&lang=ts"
import style0 from "./ImportGroup.vue?vue&type=style&index=0&id=183bb0cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183bb0cf",
  null
  
)

export default component.exports